var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenaltyShootoutEnd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11,24.53v3.7A1.09,1.09,0,0,0,12,29.32h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.79 30.23 15.79 32.23 13.17 32.23 13.17 29.08 13.17 28.32",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79,32.23v6.12a1.31,1.31,0,0,1-1.31,1.31h0a1.31,1.31,0,0,1-1.31-1.31V32.23",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.79 32.23 18.41 32.23 18.41 28.32",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79,32.23v6.12a1.31,1.31,0,0,0,1.31,1.31h0a1.31,1.31,0,0,0,1.31-1.31V32.23",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.6,
    cy: 13.45,
    r: 2.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.42,19.32a2.92,2.92,0,0,0-2.06-1h-.59a2.12,2.12,0,0,1-1.17.35,2.15,2.15,0,0,1-1.18-.35h-.55A2.92,2.92,0,0,0,11,21.23v3.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.13,24.53v3.7a1.08,1.08,0,0,1-1.08,1.09h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.13,24.53v-3.3a2.92,2.92,0,0,0-2.92-2.92h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.03,
    y1: 29.32,
    x2: 12.38,
    y2: 29.32,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12.79 13.36 12.79 2.34 37.21 2.34 37.21 13.36",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.3,
    y1: 13.36,
    x2: 48.74,
    y2: 13.36,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.26,
    y1: 13.36,
    x2: 13.23,
    y2: 13.36,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.83,
    y1: 19.67,
    x2: 25.34,
    y2: 19.67,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7.62 13.36 5.75 19.67 11.09 19.67",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "43.05 13.36 44.93 19.67 25.34 19.67",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.34,
    cy: 32.15,
    rx: 2.75,
    ry: 2.38,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.57,
    y1: 34.52,
    x2: 29.1,
    y2: 34.52,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 5.36,
    r: 0.34,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "22.49 8.67 23.71 7.46 26.3 7.46 27.51 8.66",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "23.46 13.08 23.46 11.33 24.63 10.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "26.54 13.08 26.54 11.33 25.37 10.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.77,
    y1: 8.07,
    x2: 24.77,
    y2: 9.89,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.23,
    y1: 8.07,
    x2: 25.23,
    y2: 9.89,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.83,
    y: 37.96,
    width: 19.51,
    height: 9.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.28,44.14h-2.1v-.72h1.89a.38.38,0,0,0,.37-.37v-.51a.36.36,0,0,0-.11-.27.35.35,0,0,0-.26-.1H32.18v-.69h2a.39.39,0,0,0,.27-.11.35.35,0,0,0,.1-.26v-.55a.34.34,0,0,0-.37-.37H31.08a.34.34,0,0,0-.37.37v4.5a.37.37,0,0,0,.11.27.36.36,0,0,0,.26.11h3.2a.36.36,0,0,0,.26-.11.37.37,0,0,0,.11-.27v-.55a.38.38,0,0,0-.37-.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39,40.19h-.7a.35.35,0,0,0-.26.1.39.39,0,0,0-.11.27v2.16l-1.47-2.31-.1-.12a.39.39,0,0,0-.29-.1h-.63a.36.36,0,0,0-.27.1.39.39,0,0,0-.11.27v4.5a.38.38,0,0,0,.38.38h.7a.36.36,0,0,0,.26-.11.37.37,0,0,0,.11-.27V43L38,45.26l0,.06a.4.4,0,0,0,.3.12H39a.42.42,0,0,0,.28-.12.4.4,0,0,0,.1-.26v-4.5a.39.39,0,0,0-.11-.27A.36.36,0,0,0,39,40.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.45,42.27a2.33,2.33,0,0,0-.28-1.13,1.86,1.86,0,0,0-.8-.72,3,3,0,0,0-1.24-.23H40.39a.36.36,0,0,0-.27.1.39.39,0,0,0-.11.27v4.5a.38.38,0,0,0,.38.38h1.77a3,3,0,0,0,1.22-.23,1.61,1.61,0,0,0,.79-.71,2.51,2.51,0,0,0,.28-1.16c0-.2,0-.38,0-.53S44.46,42.48,44.45,42.27Zm-1.51,1a1.3,1.3,0,0,1-.1.5.49.49,0,0,1-.23.24,1.3,1.3,0,0,1-.48.08h-.62V41.48h.58a.88.88,0,0,1,.64.19.89.89,0,0,1,.21.63v1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenaltyShootoutEnd);
export default __webpack_public_path__ + "static/media/PENALTY_SHOOTOUT_END.860d884be8edd219cc2e7e571d67d6e9.svg";
export { ForwardRef as ReactComponent };